module.exports = __webpack_public_path__ + "static/media/download_folder (2).3e8338ba.png";